module.exports = __webpack_public_path__ + "assets/certificate_pdf/Getting Started With AI On Jetson Nano_NVIDIA Deep Learning Institute_20201014.2b3ee857.pdf";